import text from './i18n/i18n.js';
import LeftNavigationMenuModule from './modules/leftNavMenu.js';
import { SectionIdentifiers } from './types/template.js';
import WhenReady from './WhenReady.js';

/**
 * A loader for content pages ( eg.  Loading Content... )
 *
 * Places the loader on pages that have a 'Left Navigation Menu' as well as
 * an anchor tag in the URL.  This is to hide the jidder of the page on load.
 *
 */
export default class Loader {
  static readonly spinnerSelector = 'template_spinner';
  static spinner: HTMLElement;

  static async initiate(cb: () => Promise<void>): Promise<void> {
    Loader.start();
    await cb();
    Loader.stop();
    return Promise.resolve();
  }
  /**
   * Conditional method that determines whether the loader executes or not
   */
  static isLoaderStartable(): boolean {
    // Is there a 'Left Navigation' present on the page ?
    const leftNavElement = LeftNavigationMenuModule.getLeftNavElement();
    const hasLeftNav = leftNavElement
      ? leftNavElement.innerHTML.length > 0
      : false;

    // Is there a hash tag in the URL of the page ?
    const hasAnchorHashTag = window.location.hash.length > 0;

    return hasLeftNav && hasAnchorHashTag;
  }

  static start(): void {
    if (Loader.isLoaderStartable()) {
      Loader.hideContent();
      const cdtsDefTopDiv =
        document.querySelector(`div#${SectionIdentifiers.TOP}`) ||
        document.querySelector(`div#${SectionIdentifiers.CUSTOM_TOP}`);
      Loader.spinner = document.createElement('div');
      Loader.spinner.classList.add('text-center');
      Loader.spinner.id = Loader.spinnerSelector;
      Loader.spinner.innerHTML = `
                <p>${text('generic.loader')}</p>
                <i class="fa fa-spinner fa-spin fa-3x"></i>
            `;

      cdtsDefTopDiv?.after(Loader.spinner);
    }
  }

  static stop(): void {
    if (document.querySelector(`#${Loader.spinnerSelector}`)) {
      WhenReady.whenTemplateModuleReady('leftNavMenu', () => {
        Loader.spinner.remove();
        Loader.showContent();
        Loader.refocusAnchorTag();
      });
    }
  }

  static showContent(): void {
    const main = document.querySelector('main');
    const leftNavElement = LeftNavigationMenuModule.getLeftNavElement();
    leftNavElement?.classList.remove('wb-inv');
    main?.classList.remove('wb-inv');
  }

  static hideContent(): void {
    const main = document.querySelector('main');
    const leftNavElement = LeftNavigationMenuModule.getLeftNavElement();
    leftNavElement?.classList.add('wb-inv');
    main?.classList.add('wb-inv');
  }

  static refocusAnchorTag() {
    const focusElement = document.querySelector(window.location.hash);
    focusElement?.scrollIntoView({ behavior: 'instant' });
  }
}
